import { render, staticRenderFns } from "./ProviderFooter.vue?vue&type=template&id=0dc743ce&scoped=true&"
import script from "./ProviderFooter.vue?vue&type=script&lang=js&"
export * from "./ProviderFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProviderFooter.vue?vue&type=style&index=0&id=0dc743ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc743ce",
  null
  
)

export default component.exports